import * as React from "react";
import { Tabs as TabsPrimitive } from "radix-ui";

import { cn } from "@/libs/cn";

import { tabsV2ListVariants, tabsV2TriggerVariants } from "./variants";

const TabsV2Root = TabsPrimitive.Root;

const TabsV2List = React.forwardRef<React.ElementRef<typeof TabsPrimitive.List>, React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>>(
  ({ className, ...props }, ref) => <TabsPrimitive.List ref={ref} className={cn(tabsV2ListVariants(), className)} {...props} />,
);

const TabsV2Trigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, ...props }, ref) => <TabsPrimitive.Trigger ref={ref} className={cn(tabsV2TriggerVariants(), className)} {...props} />);

const TabsV2Content = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content ref={ref} className={cn("w-full grow py-5 outline-none", className)} {...props} />
));

TabsV2Root.displayName = "TabsV2Root";
TabsV2List.displayName = "TabsV2List";
TabsV2Trigger.displayName = "TabsV2Trigger";
TabsV2Content.displayName = "TabsV2Content";

export { TabsV2Content, TabsV2List, TabsV2Root, TabsV2Trigger };
